import { z } from 'zod'

export const ingredientSchema = z.object({
  name: z.string().min(1).max(100),
  amount: z.number().positive(),
  unit: z.string().min(1).max(20),
})
export type Ingredient = z.infer<typeof ingredientSchema>

/** 레시피 생성 입력 — 앱 폼 검증 + API 입력 검증에 동일하게 사용 */
export const createRecipeSchema = z.object({
  title: z.string().min(1).max(120),
  description: z.string().max(2000).optional(),
  ingredients: z.array(ingredientSchema).min(1).max(50),
  steps: z.array(z.string().min(1).max(1000)).min(1).max(30),
  servings: z.number().int().min(1).max(100).default(1),
})
export type CreateRecipeInput = z.infer<typeof createRecipeSchema>

export const updateRecipeSchema = createRecipeSchema.partial()
export type UpdateRecipeInput = z.infer<typeof updateRecipeSchema>

/** API 응답용 레시피 */
export const recipeSchema = createRecipeSchema.extend({
  id: z.string(),
  userId: z.string(),
  estimatedCost: z.number().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
})
export type Recipe = z.infer<typeof recipeSchema>
